import { AvailableDays, createAvailableDays } from '../../entities/available-days/AvailableDays'
import { api, Api } from '../../services/api'
import { IAvailableDaysResponse, transformAvailableDays } from '../../transformers/available-days/AvailableDaysTransformer'
import { IAvailableDaysDataHandler } from './IAvailableDaysDataHandler'

export class AvailableDaysApiDataHandler implements IAvailableDaysDataHandler {
  api: Api
  _transformer: typeof transformAvailableDays

  constructor() {
    this.api = api
    this._transformer = transformAvailableDays
  }

  async get(): Promise<AvailableDays> {
    const {data} = await this.api.client.get<IAvailableDaysResponse>('sra_dashboard_orders_items_count')
    const transformedAvailableDays = transformAvailableDays(data)
    return createAvailableDays(transformedAvailableDays)
  }
}
